import _ from "axios";
import {
  Toast
} from "vant";
import "vant/es/toast/style";
import md5 from 'js-md5'
const axios = _.create({
  baseURL: '',
  headers: {
    "Content-Type": "application/json",
  },
});

axios.interceptors.request.use((cfg) => {
  const appid = '64';
  const appkey = "MHoEMIIxyYIgqOJb"
  const timeStamp = Date.parse(new Date()) / 1000
  cfg.headers['appid'] = appid
  cfg.headers['timeStamp'] = timeStamp
  cfg.headers['token'] = md5(appid + appkey + timeStamp)
  console.log(process.env.NODE_ENV, 'NODE_ENV')
  if (process.env.NODE_ENV === "development") {
    cfg.baseURL = process.env.VUE_APP_PROXY_KEY
  } else {
    cfg.baseURL = process.env.VUE_APP_PROXY
  }
  console.log(cfg, 'config')
  return cfg;
},

  (err) => [err.toString()]
);

axios.interceptors.response.use(
  (res) => {
    const {
      data: {
        message = "",
        code,
        data
      },
      status
    } = res;

    if (status !== 200) {
      Toast("连接失败");
      return ["连接失败"];
    } else if (code === 1) {
      return [null, data];
    } else if (code === 0 && message === "success") {
      return [null, data];
    } else {
      Toast(message);
      return [message];
    }

    // return [null, data];
  },
  (err) => {
    const {
      response
    } = err;

    if (!response) {
      Toast("未连接到服务器");
      return ["未连接到服务器"];
    }

    // 还是需要返回错误原信息,因为接口需要传递发送信息与接口的信息
    if (response && response.status) {
      Toast("请求错误");
      // return [codeMessage(response.status)];
    }
  }
);

export default axios;